import { createContext, useContext } from "react";

export const FrozenContext = createContext(false);

/** Returns whether the calling component is inside an inactive Freeze subtree. */
export default function useFrozen(): boolean {
  return useContext(FrozenContext);
}
